<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t("User") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
              >{{ alertText }}</v-alert
            >
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="$t('Username')"
                    v-model="inputUsername"
                    :error-messages="errorMessages"
                    :rules="usernameRules"
                    :class="{ 'disable-events': !updateEnable }"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="$t('Password')"
                    v-model="password"
                    color="black"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    :disabled="!updateEnable"
                    @click:append="showPassword = !showPassword"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="$t('Email')"
                    :rules="emailRules"
                    :error-messages="errorMessages"
                    :class="{ 'disable-events': !updateEnable }"
                    v-model="email"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('Name')"
                    :rules="nameRules"
                    :error-messages="errorMessages"
                    :class="{ 'disable-events': !updateEnable }"
                    v-model="name"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('Surname')"
                    :rules="surnameRules"
                    :error-messages="errorMessages"
                    :class="{ 'disable-events': !updateEnable }"
                    v-model="surname"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    v-model="selectedRoles"
                    :no-data-text="$t('No roles available')"
                    :class="{ 'disable-events': !updateEnable }"
                    :label="$t('Roles')"
                    chips
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="tzSelect"
                    :items="tzList"
                    :search-input.sync="timezoneSearch"
                    :class="{ 'disable-events': !updateEnable }"
                    cache-items
                    flat
                    hide-no-data
                    hide-details
                    :label="$t('Timezone')"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="localeSelect"
                        :items="localeList"
                        :class="{ 'disable-events': !updateEnable }"
                        :label="$t('Language')"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="darkMode"
                        :items="darkModeList"
                        :class="{ 'disable-events': !updateEnable }"
                        :label="$t('Dark Mode')"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    name="input-7-1"
                    :label="$t('Description')"
                    :rules="descriptionRules"
                    :error-messages="errorMessages"
                    :class="{ 'disable-events': !updateEnable }"
                    v-model="description"
                    rows="1"
                    auto-grow
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="primary"
                    dense
                    v-if="updateEnable"
                    @click="updateRefreshToken"
                  >
                    <v-icon left>mdi-cached</v-icon>
                    {{ $t("Update Refresh Token") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    dense
                    v-if="deleteEnable"
                    @click="deleteUser"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $t("Delete User") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t("close") }}</v-btn>
          <v-btn
            color="darken-1"
            text
            :disabled="!valid"
            v-if="updateEnable"
            @click="updateUser"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../../i18n";
import EventBus from "../../../event-bus";

export default {
  name: "UpdateUserModal",
  props: {},
  data: () => ({
    valid: true,
    showModal: false,
    loading: true,
    cardDisabled: true,
    showPassword: false,
    errorMessages: [],
    id: "",
    alertText: null,
    alertShow: false,
    username: "",
    inputUsername: "",
    usernameRules: [],
    password: "",
    passwordRules: [],
    name: "",
    nameRules: [],
    surname: "",
    surnameRules: [],
    email: "",
    emailRules: [],
    description: "",
    descriptionRules: [],
    roles: [],
    selectedRoles: [],
    tzList: [],
    timezoneSearch: null,
    tzSelect: null,
    localeList: [],
    localeSelect: null,
    updateEnable: false,
    deleteEnable: false,
    darkModeList: [],
    darkMode: null,
  }),
  created() {
    this.usernameRules = [
      (v) => !!v || i18n.t("Name is required"),
      (v) => v.length <= 50 || i18n.t("Max 50 characters"),
      (v) => (v || "").indexOf(" ") < 0 || i18n.t("No spaces are allowed"),
    ];
    this.passwordRules = [
      (v) => !!v || i18n.t("Password is required"),
      (v) => v.length <= 50 || i18n.t("Max 50 characters"),
      (v) => v.length >= 5 || i18n.t("Min 5 characters"),
      (v) => (v || "").indexOf(" ") < 0 || i18n.t("No spaces are allowed"),
    ];
    this.nameRules = [(v) => v.length <= 50 || i18n.t("Max 50 characters")];
    this.surnameRules = [(v) => v.length <= 50 || i18n.t("Max 50 characters")];
    this.emailRules = [
      (v) => !!v || i18n.t("E-mail is required"),
      (v) => /.+@.+/.test(v) || i18n.t("E-mail must be valid"),
    ];
    this.descriptionRules = [
      (v) =>
        typeof v == "undefined" ||
        v.length <= 50 ||
        i18n.t("Max 50 characters"),
    ];
    this.darkModeList = [
      {
        text: i18n.t("Default"),
        value: null,
      },
      {
        text: i18n.t("Enabled"),
        value: true,
      },
      {
        text: i18n.t("Disabled"),
        value: false,
      },
    ];
  },
  watch: {
    inputUsername: function (val) {
      if (val != this.username && val != "") {
        axios({
          url: "/api/v1/permissions/username/" + val,
          headers: { "Content-Type": "application/json" },
          method: "GET",
        })
          .then((response) => {
            if (
              !response.data ||
              !response.data.status ||
              !(response.data.status == "done")
            ) {
              this.errorMessages = [];
            } else {
              if (response.data.username) {
                this.errorMessages = [i18n.t("Username already exists!")];
              } else {
                this.errorMessages = [];
              }
            }
          })
          .catch(() => {
            this.errorMessages = [];
          });
      }
    },
    timezoneSearch(val) {
      val && val !== this.select && this.timezonesQuerySelections(val);
    },
  },
  mounted() {
    // Permissions
    let permissions = this.$store.getters.resources.permissions;

    if (permissions.users.delete) {
      this.deleteEnable = true;
    }

    if (permissions.users.update) {
      this.updateEnable = true;
    }
  },
  methods: {
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    show(id) {
      // Add defaults to timezone and locale.
      this.tzList = this.$tzList.slice();
      this.tzList.unshift(i18n.t("Default"));

      this.localeList = [];

      for (let i = 0; i < this.$localeList.length; i++) {
        this.localeList.push({
          text: i18n.t(this.$localeList[i].text),
          value: this.$localeList[i].value,
        });
      }

      this.localeList.unshift({ text: i18n.t("Default"), value: "Default" });
      this.localeSelect = "Default";

      this.showModal = true;
      this.alertShow = false;
      this.alertText = "";

      let getUser = axios.get("/api/v1/permissions/user/" + id);
      let getRoles = axios.get(
        "/api/v1/permissions/roles?filter=id,name&gui=true"
      );

      axios
        .all([getUser, getRoles])
        .then(
          axios.spread((...responses) => {
            const user = responses[0];
            const roles = responses[1];

            this.loading = false;
            this.cardDisabled = false;
            this.id = user.data.user.id;
            this.username = user.data.user.username;
            this.inputUsername = user.data.user.username;
            this.email = user.data.user.email;
            this.localeSelect = user.data.user.locale;

            if ("name" in user.data.user) this.name = user.data.user.name;

            if ("surname" in user.data.user)
              this.surname = user.data.user.surname;

            if ("description" in user.data.user)
              this.description = user.data.user.description;

            if (user.data.user.timezone != "Default") {
              let tz = user.data.user.timezone.replace("_", " ");
              this.tzSelect = tz;
            } else {
              this.tzSelect = i18n.t("Default");
            }

            this.roles = roles.data.list;
            this.selectedRoles = [];

            for (let i = 0; i < user.data.user.roles.length; i++) {
              this.selectedRoles.push(user.data.user.roles[i].id);
            }

            if ("darkMode" in user.data.user)
              this.darkMode = user.data.user.darkMode;
          })
        )
        .catch((errors) => {
          this.sendErrorAndCloseModal(errors);
        });
    },
    updateRefreshToken() {
      this.loading = true;

      axios({
        url: "/api/v1/permissions/user/updateRefreshToken/" + this.id,
        method: "PUT",
      })
        .then((response) => {
          this.loading = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.showModal = false;
            EventBus.$emit("SHOW_ERROR", response);
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    updateUser() {
      this.loading = true;

      let data = {};

      if (this.inputUsername != "" && this.username != this.inputUsername) {
        data.username = this.inputUsername;
      }

      if (this.password != "") {
        data.password = this.password;
      }

      if (this.email != "") {
        data.email = this.email;
      }

      if (this.name != "") {
        data.name = this.name;
      }

      if (this.surname != "") {
        data.surname = this.surname;
      }

      if (this.description != "") {
        data.description = this.description;
      }

      let roles = [];

      for (let i = 0; i < this.selectedRoles.length; i++) {
        roles.push(this.selectedRoles[i]);
      }

      if (this.tzSelect != i18n.t("Default")) {
        data.timezone = this.tzSelect.replace(" ", "_");
      } else {
        this.tzSelect = i18n.t("Default");
      }

      if (this.localeSelect != "Default") {
        data.locale = this.localeSelect;
      }

      if (this.darkMode != null) {
        data.darkMode = this.darkMode;
      }

      data.roles = roles;

      axios({
        url: "/api/v1/permissions/user/" + this.id,
        headers: { "Content-Type": "application/json" },
        data: data,
        method: "PUT",
      })
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.showModal = false;
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorOnModal(error);
        });
    },
    deleteUser() {
      this.loading = true;

      axios({
        url: "/api/v1/permissions/user/" + this.id,
        method: "DELETE",
      })
        .then((response) => {
          this.loading = false;
          this.showModal = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.$parent.$parent.updateTable();
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    timezonesQuerySelections(v) {
      this.tzlist = this.$tzList.filter((e) => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
    },
    hide() {
      this.showModal = false;
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}

.disable-events {
  pointer-events: none;
}

.outlinedButton {
  padding: 0px !important;
}
</style>